import { connect, ConnectedProps } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { createDecisionFolder, addDecisionFolder } from '../state/actions';

type Props = {
  docId: string;
  queryKey: string;
};

const mapDispatch = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { docId, queryKey }: Props,
) => ({
  async createNewFolder({ title, source }: { title: string; source: string }) {
    const folder = await dispatch(
      createDecisionFolder({
        title,
        docId,
        queryKey,
        source,
      }),
    );
    return folder;
  },
  saveInFolder({
    searchActive,
    folderKey,
  }: {
    searchActive: boolean;
    folderKey: string;
  }) {
    dispatch(
      addDecisionFolder(
        docId,
        folderKey,
        queryKey,
        'addDecision',
        searchActive,
      ),
    );
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
